import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormInput from '../../../../library/form/components/FormInput';
import FormCheckbox from '../../../../library/form/components/FormCheckbox';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle'
import FormWrapper from '../../../../library/form/components/FormWrapper';
import FormSH from '../../../../library/form/components/FormSH';

const UserHeaderEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if(!viewData)
        return(null)

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '370px' }}
            formStyle={{ width: '743px' }} formTitle={<FormTitle formObject={formObject} value="User Header" />}
        >
            <div>
                <div  className="uiEditableContent" id="editor">
                    <div className="uiCol">
                        <ul>
                            <li>
                                <span className="uiLbl"><SarasTrans value = "User ID"/></span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "userId" }} className='uiVal' />
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "profileContainer" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profileType" }} value="Relation" />
                                </span>
                                <FormInput formObject={formObject} rowKey=""  className="uiVal"
                                    action={{
                                        InputType: "ac", paramName: "profileType", acMethod: "DocumentTypeByModule",
                                        acDepCtrl: { dparam: '7' }
                                    }}
                                />
                            <FormSH formObject={formObject} rowKey="" action={{
                                actionId: "new", paramName: "profile", 
                                actionName: "proComp", actionParam: {}, containerKey: "popup"
                            }} >
                            </FormSH>
                            </FormWrapper>

                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "profileContainer" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile" }} value="Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                    action={{
                                        InputType: "ac", paramName: "profile", acMethod: "ProfileName",
                                        acDepCtrl: { dparam: '#profileType', reqPerm: 1 }, actionParam:{updateProfile:1}
                                    }}
                                />
                            </FormWrapper>

                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "title" }} value="Title" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal "
                                action={{ InputType: "input", paramName: "title" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "firstName" }} value="First Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "firstName" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "middleName" }} value="Middle Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "middleName" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lastName" }} value="Last Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "lastName" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "workflowGroup" }} value="Workflow Group" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal" gid="full"
                                    action={{
                                        InputType: "ac", paramName: "workflowGroup", acMethod: "CategoryDetail",
                                        acDepCtrl: { dparam: '15' }
                                    }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "department" }} value="Department" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal" gid="full"
                                    action={{
                                        InputType: "ac", paramName: "department", acMethod: "CategoryDetail",
                                        acDepCtrl: { dparam: '32' }
                                    }}
                                />
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "svDepartment" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lineHead" }} value="Line Head" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal" gid="full"
                                    action={{
                                        InputType: "ac", paramName: "lineHead", acMethod: "UserNames",
                                    }}
                                />
                                
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "svLineHead" }} className='uiVal' />

                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "userStatus" }} value="Is Active ?" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey=''
                                    action={{ InputType: "onOff", paramName: "userStatus" }}
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="uiCol">
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nickName" }} value="Nick Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "nickName" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "email1" }} value="Email 1" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "email1" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mobile1" }} value="Mobile 1" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "mobile1" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "userlogin" }} value="Login ID" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal" gid="full"
                                action={{ InputType: "input", paramName: "userlogin" }} />

                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "svLoginId" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "userPass" }} value="Password" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal" gid="full"
                                action={{ InputType: "password", paramName: "userPass" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "language" }} value="Default Language" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "ac", paramName: "language", acMethod: "ActiveCulture" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sortIndex" }} value="Sort Order" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "sortIndex" }} />
                            </li>
                            <li>
                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "portal" }} value="Portal Access ?" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey=''
                                    action={{ InputType: "onOff", paramName: "portal" }}
                                />

                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "device" }} value="App Access ?" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey=''
                                action={{ InputType: "onOff", paramName: "device" }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "devLimit" }} value="Device Limit" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal" 
                                action={{ InputType: "input", paramName: "devLimit" }} />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </FormDialog>
    )
}

export default withView(UserHeaderEditor, "userHead", "userHead")